import {
  AfterViewInit,
  Component,
  EventEmitter, Inject,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import {IBounds, ILedInfo} from "../../../../models/common";
import {DataSource} from '@angular/cdk/table';
import {select} from "@angular-redux/store";
import {tassign, Utils} from "../../../../common/utils";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {isNullOrUndefined} from "util";
import {BehaviorSubject, combineLatest, Observable, Subscription} from "rxjs";
import {debounceTime} from "rxjs/operators";
import {LabelType, Options} from "@angular-slider/ngx-slider";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";


interface IColInfo {
  label: string;
  field: string;
  unit: string;
}

const ALL_STRING = '[all]';

@Component({
  selector: 'edsng-led-preselect-dialog',
  templateUrl: './led-preselect-dialog.component.html',
  styleUrls: ['./led-preselect-dialog.component.css', './led-preselect-dialog.component.mobile.css'],
  encapsulation: ViewEncapsulation.None
})
export class LedPreselectDialogComponent implements OnInit, OnDestroy, AfterViewInit {

  private static _displayedColumnsInfo = [
    { label: 'manufacturer', field: 'Manufacturer', unit: null, class: 'flex_container flex2' },
    { label: 'family', field: 'Family', unit: null, class: 'flex_container flex2' },
    { label: 'partnumber', field: 'PN', unit: null, class: 'flex_container flex2' },
    { label: 'vf', field: 'VF', unit: 'V' },
    //    , {label:'VFMax', field:'VFMax', unit:'V'}
    { label: 'if', field: 'IF', unit: 'A' },
    { label: 'rd', field: 'Rd', unit: 'Ω' },
    { label: 'color', field: 'Color', unit: null },
    { label: 'flux', field: 'Flux', unit: null }
  ];

  obsHandle: Subscription[] = [];

  displayedColumnsInfo = LedPreselectDialogComponent._displayedColumnsInfo;

  get displayedColumns() {
    return this.displayedColumnsInfo.map(({ field }) => field);
  }

  dataSource: LedsDataSource | null;
  _selectedItem: ILedInfo = null;

  db: BehaviorSubject<ILedInfo[]> = new BehaviorSubject<ILedInfo[]>([]);

  // @Input() showTable:boolean=true;
  @Output() selectedItem: EventEmitter<ILedInfo> = new EventEmitter<ILedInfo>();
  colorFilter: BehaviorSubject<string> = new BehaviorSubject<string>(ALL_STRING);
  vfFilter: BehaviorSubject<IBounds> = new BehaviorSubject({min: Number.NEGATIVE_INFINITY, max: Number.POSITIVE_INFINITY});
  ifFilter: BehaviorSubject<IBounds> = new BehaviorSubject({min: Number.NEGATIVE_INFINITY, max: Number.POSITIVE_INFINITY});
  page: BehaviorSubject<PageEvent> = new BehaviorSubject({pageIndex: 0, pageSize: 5, length: 5 });
  numLeds: number;

  colors = [ALL_STRING];
  vfBounds = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };
  ifBounds = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };

  @select(['appCatalog', 'ledDB']) ledDB$: Observable<ILedInfo[]>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  _optionSliderVF = {
      ceil: 100, /*this.vfBounds.max === Number.NEGATIVE_INFINITY ? 100 : this.vfBounds.max,*/
      floor: 0, /*this.vfBounds.min === Number.POSITIVE_INFINITY ? 0 : this.vfBounds.min,*/
      step: 1, /*(this.vfBounds.max === Number.NEGATIVE_INFINITY || this.vfBounds.min === Number.POSITIVE_INFINITY) ? 1 : (this.vfBounds.max - this.vfBounds.min) / 100,*/
      translate: (value: number, label: LabelType): string => {
        return ValueFormatter.autoFormat(value, 'V');
    }
  };

  get optionSliderVF(): Options {
    // this._optionSliderVF = tassign(this._optionSliderVF, {ceil: this.vfBounds.max, floor: this.vfBounds.min, step: (this.vfBounds.max - this.vfBounds.min) / 100});
    return this._optionSliderVF;
  }

  _optionSliderIF = {
      ceil: 10, /*this.ifBounds.max,*/
      floor: 0, /*this.ifBounds.min,*/
      step: 0.1, /*(this.ifBounds.max - this.ifBounds.min) / 100,*/
      translate: (value: number, label: LabelType): string => {
        return ValueFormatter.autoFormat(value, 'A');
      }
  };

  get optionSliderIF(): Options {
    // this._optionSliderIF = tassign(this._optionSliderIF, {ceil: this.ifBounds.max, floor: this.ifBounds.min, step: (this.ifBounds.max - this.ifBounds.min) / 100});
    return this._optionSliderIF;
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<LedPreselectDialogComponent>, public renderer: Renderer2) {
    this.selectRow(data.selectedRow);
  }

  ngOnDestroy() {
    // console.log('Destroy led dialog');
    this.obsHandle.forEach(x => {if (!isNullOrUndefined(x)) {x.unsubscribe(); }});
  }

  ngOnInit() {
    this.dataSource = new LedsDataSource(this.db);

    this.obsHandle.push(combineLatest([
      this.ledDB$,
      this.vfFilter,
      this.ifFilter,
      this.colorFilter,
      this.page
      ]).pipe(
        debounceTime(50)                          // to avoid multi execution of the same parameters at start-up
      )
      .subscribe(([x, v, i, c, p]) => {
      if (!isNullOrUndefined(x) && !isNullOrUndefined(v) && !isNullOrUndefined(i) && !isNullOrUndefined(c) ) {
        const f = x.filter(a => {
          const _vf = Number.parseFloat(a.VF);
          const _if = Number.parseFloat(a.IF);

          return (a.Color === c || c === ALL_STRING) &&
            (_vf >= v.min && _vf <= v.max) &&
            (_if >= i.min && _if <= i.max);
        });
        const currentPage = Math.min(Math.ceil(f.length /  p.pageSize) - 1, p.pageIndex) ;
        this.paginator.pageIndex = currentPage;
        this.numLeds = f.length;

        this.db.next(f.filter((_x, _i) => (currentPage * p.pageSize) <= _i && _i < ((currentPage + 1) * p.pageSize)));
        // this.db$.next(f);
      }
    }));

    this.obsHandle.push(this.ledDB$.subscribe(x => {
      // console.log("Change ledDB$????", x.length );
      let vMin = Number.POSITIVE_INFINITY;
      let vMax = Number.NEGATIVE_INFINITY;
      let iMin = Number.POSITIVE_INFINITY;
      let iMax = Number.NEGATIVE_INFINITY;

      if (!isNullOrUndefined(x)) {
        x.forEach(a => {
          const _vf = Number.parseFloat(a.VF);
          const _if = Number.parseFloat(a.IF);

          if (!this.colors.includes(a.Color)) {
            this.colors.push(a.Color);
          }

          if (vMin > _vf) {
            vMin = _vf;
          }
          if (vMax < _vf) {
            vMax = _vf;
          }

          if (iMin > _if) {
            iMin = _if;
          }
          if (iMax < _if) {
            iMax = _if;
          }

        });

        this.colors.sort((a, b) => a === ALL_STRING ? -1 : a.localeCompare(b));

        // this to refresh properly the scroll bar
        setTimeout(() => {

          this._optionSliderIF = tassign(this._optionSliderIF, {ceil: iMax, floor: iMin, step: (iMax - iMin) / 100});
          this._optionSliderVF = tassign(this._optionSliderVF, {ceil: vMax, floor: vMin, step: (vMax - vMin) / 100});

          this.ifBounds.max = iMax;
          this.ifBounds.min = iMin;
          this.vfBounds.max = vMax;
          this.vfBounds.min = vMin;

        }, 500);

        this.vfFilter.next(this.vfBounds);
        this.ifFilter.next(this.ifBounds);
      }
    }));

    this.obsHandle.push(this.paginator.page.subscribe(x => this.page.next(x)));

  }

  ngAfterViewInit() {

    /**
     * Poter modificare le classi che angular material messe tramite style.
     * Se non vengono modificate dinamicamente nell'ngAfterViewInit, le classi di angular material hanno precedenza
     */
    this.renderer.setStyle(document.getElementsByClassName('mat-dialog-container')[0], 'padding', '0');
    if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
      this.renderer.addClass(document.getElementsByClassName('tableLedPreselected')[0], 'safari');
      this.renderer.addClass(document.getElementsByClassName('scrollPreselectDialog')[0], 'safari');

      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.renderer.addClass(document.getElementsByClassName('tableLedPreselected')[0], 'mobile');
        this.renderer.addClass(document.getElementsByClassName('scrollPreselectDialog')[0], 'mobile');
      }
    }
  }

  closeDlg(msg: string) {
    if (msg === 'ok' && this._selectedItem !== null) {
      this.selectedItem.emit(this._selectedItem);
    }
      this.closeDialog(msg);
  }


  closeDialog(msg?) {
    this.dialogRef.close(msg);
  }

  public static openDialog(dialog: MatDialog, selectedRow?: ILedInfo): MatDialogRef<LedPreselectDialogComponent> {

    const config = new MatDialogConfig();
    config.disableClose = true;
    config.width = '1097px';
    config.data = {selectedRow: selectedRow};
    // config.id = "ledPreselectDialog";
    // config.height = '500px';
    return dialog.open(LedPreselectDialogComponent, config);

  }


  selectRow(row: ILedInfo) {

    if (this._selectedItem && this._selectedItem === row) {
      this._selectedItem = null; // deselect
    } else {
      this._selectedItem = row;
      //    this.selectedItem.emit(this._selectedItem);
    }
  }

  getField(row: ILedInfo, i: IColInfo): string {

    if (i.unit !== null) {
      const valStr: string = Utils.getFieldValue(row, i.field);
      if (valStr !== null) {
        const val: number = Number.parseFloat(valStr);
        return ValueFormatter.autoFormat(val, i.unit);
      }
      return 'N.A.';
    }
    return Utils.getFieldValue(row, i.field, 'N.A.');
  }

  filterColor(val) {
    // console.log("COLOR CHANGE",val);
    if (this._selectedItem != null && val !== this._selectedItem.Color) {
      this._selectedItem = null;
    }
    this.colorFilter.next(val);
  }

  adjustScrollbar() {
      this.renderer.addClass(document.getElementsByClassName('ng-trigger-transformPanel')[0], 'scrollbar_custom');
  }

  changeVFRange(evt, param) {
    const val = evt;
    // console.log("changeVFRange", param, val, this.vfBounds);
    const a = this.vfFilter.getValue();
    const _vf: IBounds = { min: a.min, max: a.max };

    if (param === 'min') {
      _vf.min = val;
    }
    if (param === 'max') {
      _vf.max = val;
    }
    if (_vf.min > _vf.max) {
      const b = _vf.min;
      _vf.min = _vf.max;
      _vf.max = b;
    }
    this.vfFilter.next(_vf);
  }

  changeIFRange(evt, param) {
    const val = evt;
    const a = this.ifFilter.getValue();
    const _if: IBounds = { min: a.min, max: a.max };

    if (param === 'min') {
      _if.min = val;
    }
    if (param === 'max') {
      _if.max = val;
    }
    if (_if.min > _if.max) {
      const b = _if.min;
      _if.min = _if.max;
      _if.max = b;
    }
    this.ifFilter.next(_if);
  }
}



/**
* Data source to provide what data should be rendered in the table. Note that the data source
* can retrieve its data in any way. In this case, the data source is provided a reference
* to a common data base, UserFileDatabase. It is not the data source's responsibility to manage
* the underlying data. Instead, it only needs to take the data and send the table exactly what
* should be rendered.
*/
class LedsDataSource extends DataSource<any> {
  constructor(private db: BehaviorSubject<ILedInfo[]>) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<ILedInfo[]> {
    return this.db;
  }

  disconnect() { }
}
